import { App, Component, createApp, h, ref } from 'vue';
import ModalComponent from '@use/useModal/ModalComponent.vue';
import ModalGallery from '@use/useModal/ModalGallery.vue';

import VueUniversalModal from 'vue-universal-modal';
import { storePinia } from '@/storePinia';

let app: App | null = null;

const { body } = document;

body.insertAdjacentHTML('beforeend', '<div class="modal-component"></div>');
body.insertAdjacentHTML('beforeend', '<div id="modals"></div>');
const isOpen = ref(true);
interface IProps {
  [name: string]: any;
}

interface IOptions {
  width?: string;
  widthTablet?: string;
  widthDesktop?: string;
  backgroundClose?: boolean;
  padding?: boolean;
  zIndex?: number;
}
let callBack: (() => void) | undefined;
export default function useModal() {
  const show = (AppComponent: Component, props?: IProps, options?: IOptions) => {
    if (app !== null) {
      app?.unmount();
    }

    isOpen.value = true;

    app = createApp(<ModalComponent>{{ default: () => h(AppComponent, props) }}</ModalComponent>, {
      isOpen,
      options,
      afterLeave: () => {
        app?.unmount();
        callBack?.();
        app = null;
      },
    });
    app.use(VueUniversalModal, {
      teleportTarget: '#modals',
    });

    app.use(storePinia);

    app.mount('.modal-component');
  };

  const showGallery = (AppComponent: Component, props?: IProps, options?: IOptions) => {
    // if (isOpen.value) {
    //   app?.unmount();
    // }

    isOpen.value = true;

    app = createApp(<ModalGallery>{{ default: () => h(AppComponent, props) }}</ModalGallery>, {
      isOpen,
      options,
      afterLeave: () => {
        app?.unmount();
        callBack?.();
        app = null;
        // if (options?.afterLeave) {
        //   options.afterLeave();
        // }
      },
    });

    app.use(VueUniversalModal, {
      teleportTarget: '#modals',
    });

    app.use(storePinia);

    app.mount('.modal-component');
  };

  const hide = (): Promise<void> => {
    if (!app) {
      return new Promise((resolve) => {
        resolve();
      });
    }

    isOpen.value = false;
    return new Promise((resolve) => {
      callBack = resolve;
    });
  };

  return {
    show,
    hide,
    showGallery,
  };
}
